import { render, staticRenderFns } from "./portfolio-repayment-v3.vue?vue&type=template&id=f6407b72&scoped=true&"
import script from "./portfolio-repayment-v3.vue?vue&type=script&lang=js&"
export * from "./portfolio-repayment-v3.vue?vue&type=script&lang=js&"
import style0 from "./portfolio-repayment-v3.vue?vue&type=style&index=0&id=f6407b72&scoped=true&lang=css&"
import style1 from "./portfolio-repayment-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6407b72",
  null
  
)

export default component.exports